// AUTO-GENERATED by scripts/gen-version.js — do not edit by hand.
// Regenerated on every "npm start" / "npm run build".
export const APP_VERSION = "1.0.39";
export const BUILD_TIME = "2026-11-03T07:54:12.983Z";
export const BUILD_ID = "1.0.39+2026-11-03T07:54:12.983Z";
